<template>
    <div class="map">
        <div class="google-map" id="map"></div>
    </div>
</template>
<script>
import firebase from 'firebase'
import db from '@/firebase/init'
export default {
    name: 'GMap',
    data() {
        return {
            lat:53,
            lng:-2
        }
    },
    methods: {
        renderMap(){
            const map = new google.maps.Map(document.getElementById('map'),{center: {lat:this.lat ,lng:this.lng},
            zoom:6,
            minZoom:3,
            maxZoom:15,
            streetViewControl:false})
        //look into database grab users (because it is asynchronous we put then() which is a call back function
        //and return a promise), i grab document for each user and grab the location of each user
        db.collection('users').get().then(users => {
            users.docs.forEach(doc => {
                let data = doc.data()
                if (data.geolocation) {
                    //create a marker with lat and lngt taken from each record in database
                    let marker = new google.maps.Marker({
                        position: {lat: data.geolocation.lat, lng:data.geolocation.lng},
                        //put marker on this map map:map can be written as map
                        map
                        })
                        //add function click to marker, when marker is clicked it fires a function
                        marker.addListener('click',()=>{
                            this.$router.push({name: 'ViewProfile', params: {id: doc.id}})
                        })
                    }
                })
            })
        }
    },
    mounted(){
        //get current user
        let user = firebase.auth().currentUser
        console.log(user)
        // get user geolocaion then render the map
        // not every browser has geolocation api so just render with default coords
        // to check if geolocation exists in navigator
        if(navigator.geolocation){
            // getCurrentPosition() is a synchronous function takes pos(coords of the current user) as a param
            navigator.geolocation.getCurrentPosition(pos=> {
                this.lat= pos.coords.latitude
                this.lng= pos.coords.longitude
                //find the user record in firestore to enter coords into database
                db.collection('users').where('user_id','==',user.uid).get()
                .then(snapshot=> {
                    //it will return a group of reords and we have to use forEach although it will return one record
                    snapshot.forEach((doc) => {
                        db.collection('users').doc(doc.id).update({
                            geolocation: {lat: pos.coords.latitude, lng: pos.coords.longitude}
                        }) 
                    })
                }).then(()=>{this.renderMap()})
                }, err=>{
                    console.log(err)
                    this.renderMap()}, {maximumAge:60000, timeout:3000})
            } else {
                // position map center by default position
                this.renderMap()}
    }
}
</script>
<style>
.google-map {
    width: 100%;
    height: 100%;
    margin: 0 auto;
    position: absolute;
    z-index: -1;
    top:0;
    left:0;
}
</style>





// WEBPACK FOOTER //
// src/components/home/GMap.vue